<template>
<div id="container" class="piratengeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/piratengeschichten/Hintergrund_2860.jpg" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/piratengeschichten/Moeve.png" />
    </div> -->

    <div class="schwimmer z30 hovering">
        <!-- <img class="img" src="/static/assets/piratengeschichten/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/piratengeschichten/Schiff.png" />
    </div>
    <div class="fernglas z30">
        <img class="img" src="/static/assets/piratengeschichten/Fernglas.png" />
    </div>
    <div class="steuermann z30">
        <img class="img" src="/static/assets/piratengeschichten/Steuermann.png" />
    </div>
    <!-- <div class="koechin z30">
        <img class="img" src="/static/assets/piratengeschichten/Koechin.png" />
    </div> -->
    <div class="libero z30">
        <img class="img" src="/static/assets/piratengeschichten/Libero.png" />
    </div>
    <div class="hui z30">
        <img class="img" src="/static/assets/piratengeschichten/Hui.png" />
    </div>
    <div class="dubix z30">
        <img class="img" src="/static/assets/piratengeschichten/Dubix.png" />
    </div>
    <div class="gigikaeptn gigikaeptn_animation z30">
        <!-- <img class="img" src="/static/assets/piratengeschichten/Gigi_Kaeptn.png" /> -->
    </div>
    <!-- <div class="schild z34">
        <img class="img" src="/static/assets/piratengeschichten/Schild.png" />
    </div> -->
    <div class="gras z35">
        <img class="img" src="/static/assets/piratengeschichten/Gras.png" />
    </div>

    <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/zaubergeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/piratengeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Kaeptn_Ahoi.mp3" jsonurl="/static/assets/geschichten/gigi.timings.json" content=".piratengeschichten" target="piratengeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="piratengeschichten_target">
        <p>Ahoi! Die Piraten sind los! Schon vor einem Monat stachen die Hugidubies mit ihrem Schiff in See. Ihre Fahrt sollte sieben Monate dauern und sie über die sieben Meere zu einer verborgenen Insel namens Maniti führen. Dort hatte Hui Maats Urururoma vor langer, langer Zeit einen Schatz versteckt, der von dem Seeungeheuer Karüptis bewacht wurde.
Der Wind war sehr günstig und so segelten sie fröhlich auf die Insel Maniti zu. Die Sonne lachte, Svenja Smutje zauberte in der Kombüse mit ihren Kochbüchern köstliche Speisen und Dubix Seebär hatte in seiner Bordbuchhandlung lauter tolle Bücher. Ein wunderbares Seeräuberleben — bis plötzlich schwerer Seegang aufkam. Plumps! Schon fiel Hui Maat samt Buch aus der Hängematte. Autsch! Da landete ein Buch auf Dubix Seebärs Kopf. Wie staunten die Piraten, als ihr Schiff langsam emporgehoben wurde und unter dem Bug ein freches Riesengesicht zum Vorschein kam. „Oh, ohje!“, riefen die Piraten. „Das ist Klabauter!“ Ja, das musste das Seeungeheuer Klabauter sein, von dem Hui Maats Uroma ihrem Urenkel immer erzählt hatte. Sie wiederum kannte die Geschichte von ihrer Oma, jener, die damals den Schatz versteckt hatte. Hui Maat wollte seiner Uroma nie so recht glauben. Jetzt aber war Klabauter da — direkt unter ihnen — und er drohte, ihr Schiff kentern zu lassen!</p>
<p>„Grrr, grrr!“, Bootshund Libero war außer sich. Er bellte und knurrte Klabauter wütend an. Die Piraten hingegen waren ratlos und blickten zu Gigi Käpt’n, schließlich hatten sie Gigi zu ihrer Kapitänin gemacht, weil sie so schlau war und immer die schlausten Bücher las. Und Gigi dachte nach, sie dachte schnell nach, das sah man daran, dass sie ihre Lippen einzog, bis sie fast nicht mehr zu sehen waren. Selbst Libero verstummte und sah Gigi erwartungsvoll an. „Klabauter langweilt sich, weil er allein lebt“, überlegte sie laut. „Wenn er einen Freund hätte, würde er sich nicht langweilen und die Schiffe in Ruhe lassen. Wir wissen aber, wo ein anderes Seeungeheuer lebt, und Klabauter einen Freund finden kann!“ Sprach’s und rief freundlich vom Bug des Schiffes hinunter: „Hey, Klabauter, wenn du uns nicht mehr ärgerst, nehmen wir dich mit zur Insel Maniti. Dort wirst du deinesgleichen finden und nie mehr allein sein!“</p>
<p>Klabauter traute seinen Ohren nicht. Noch nie hatten Seeleute nett mit ihm gesprochen. Ob er ihnen glauben sollte? Was hatte er schon zu verlieren! Wenn es nicht stimmte, was diese Kapitänin da oben sagte, könnte er ihr Schiff immer noch kentern lassen.</p>
<p>So kam es, dass Klabauter sechs Monate später Hochzeit feierte. Es hatte sich nämlich herausgestellt, dass das Seeungeheuer Karüptis eine Seeungeheuerin war. Beide lebten fortan glücklich zusammen, bekamen viele kleine Seeungeheuer, ließen aber Schiffe und Seeleute in Frieden. Die Piraten jedoch freuten sich unbändig über das, was sie in der goldbeschlagenen Schatztruhe fanden: Die Lieblingsbücher von Hui Maats Urururoma! Auch einen Brief hatte die alte Piratendame hinterlassen, auf dem nur vier Worte standen:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Piratengeschichten',
  data () {
    return {
      who: 'Piratengeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Gigi_Titel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Piraten_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* piratengeschichten */
.piratengeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.piratengeschichten .himmel { display: block !important; }

.piratengeschichten .geschichte { position: absolute; top: 170px; left:51%;  }

.piratengeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.piratengeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* .piratengeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.piratengeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.piratengeschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.piratengeschichten .fernglas {position: absolute; /* left: 36%; top: 74%; */ left: 37%; bottom: 4%; }
.piratengeschichten .fernglas {animation: fernglas_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes fernglas_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.piratengeschichten .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.piratengeschichten .steuermann {position: absolute; left: 1%; bottom: 13%;}
.piratengeschichten .steuermann {animation: steuermann_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes steuermann_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.piratengeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.piratengeschichten .hui {position: absolute; right: 6%; bottom: 45%;}
.piratengeschichten .hui {animation: hui_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hui_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.piratengeschichten .dubix {position: absolute; left: 11%; bottom: 37%;}
.piratengeschichten .dubix {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.piratengeschichten .libero {position: absolute; left: 15%; bottom: 24%;}
.piratengeschichten .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.piratengeschichten .gigikaeptn {position: absolute; /* left: 23%; bottom: 6%; */ left: 22%; bottom: 16%; }
/* .piratengeschichten .gigikaeptn_animation {animation: gigikaeptn_erscheint 0.5s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigikaeptn_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
} */
.piratengeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.piratengeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.piratengeschichten .hovering {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}

/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.piratengeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}

.gigikaeptn_animation {
  width: 350px;
  height: 350px;
  background: url('/static/assets/piratengeschichten/Gigi_Kaeptn_Sprite.png') top center;
  animation-delay: 2s;
  animation: gigikaeptn_dubix 4s steps(15) infinite;
  transform: scale(1);
  margin-top:-25px;
}

@keyframes gigikaeptn_dubix {
    100% { background-position: 0 -5250px; }
}
span { font-family: FrozenMemory; }
.geschichte .player { top: 644px !important; }
</style>



// WEBPACK FOOTER //
// src/components/Piratengeschichten.vue